<template>
    <div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import io from 'socket.io-client';
import getEnv from '@/utils/env'
export default {
    computed: {
    ...mapGetters('ChatController', ['unreadMessages']),
    },
    methods: {
        ...mapMutations("ChatController", ['SET_UNREAD_MESSAGE']),
        ...mapActions("UserController", [
        "USER_PROFILE",
        "USER_LOGOUT"
        ]),
        
    },
    async created() {
        try {
            let mgr = await this.$root.mgr();
            var sigInResult = await mgr.signinRedirectCallback();
            await this.$root.authenticate();
            this.$root.initSocket();
            this.USER_PROFILE()
                .then((result) => {
                    if (sigInResult && sigInResult.state) {
                            this.$router.push(this.$i18nRoute({ name: sigInResult.state }));
                    }
                    else {
                        this.$router.replace('/');
                    }
                });
        }
        catch {
           this.USER_LOGOUT()
                .then((result) => {
                    this.$router.replace("/");
                })
        }
    }
}
</script>